import React, {Component} from 'react';
const { connect } = require('react-redux');

import 'sass/member/MemberWallPosts.scss';

import Footer from '../../components/Footer';
import HeaderMemberWallPosts from 'components/member/HeaderMemberWallPosts';
import WallMaterialList from 'components/list/WallMaterialList'

import {getMemberWallMaterials, memberDeleteWallPost} from 'reducers/memberWallMaterials';

class MemberWallPosts extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showModal: false,
            openedMemberPhoto: null
        }
    }

    componentDidMount() {
        this.props.getMemberWallMaterials();
    }

    render() {
        let {currentUser, memberWallMaterials} = this.props,
            {list} = memberWallMaterials;

        return (
            <div id="wrapper">
                <HeaderMemberWallPosts onPostAddSuccess={() => this.props.getMemberWallMaterials()}/>

                <aside className="memberwallposts">
                    <div className="content">
                        <WallMaterialList wallMaterials={list} onDelete={this.props.memberDeleteWallPost} currentUser={currentUser} showAuthor={false} responsiveGrid/>
                    </div>
                </aside>

                <Footer />
            </div>
        )
    }
}

export default connect(
    state => ({
        currentUser: state.currentUser,
        memberWallMaterials: state.memberWallMaterials
    }), ({
        getMemberWallMaterials: getMemberWallMaterials,
        memberDeleteWallPost: memberDeleteWallPost
    })
)(MemberWallPosts)


// WEBPACK FOOTER //
// ./src/containers/member/MemberWallPosts.js